import { useI18n as baseUseI18n } from 'vue-i18n';
// import type { Translations } from './i18n';

// ✨ Typed useI18n for all your autocomplete needs ✨
/**
 * SADNESS: this quadruples the type-check time for the app - commenting out for now
 * (until ts-go lands in vue OR we restructure where i18n files are located and imported)
 * */
// export const useI18n = () => baseUseI18n<{ message: Translations['en'] }, 'en'>();

export const useI18n = () => baseUseI18n();
